module.exports = __webpack_public_path__ + "4f73f4aeb60e1a96afec367806f6d9ec.svg";